// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CSS Variables from Config - Fonts loaded dynamically via JavaScript */
:root {
  /* Typography - These will be overridden by JavaScript with values from config */
  --font-family-primary: 'Montserrat', sans-serif;
  --font-family-scrolling: 'Bebas Neue', sans-serif;
  --font-family-footer: 'Josefin Sans', sans-serif;
  --font-family-fallback: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  
  /* Colors */
  --color-primary: #E63E96;
  --color-primary-dark: #B91C7C;
  --color-secondary: #202020
;
  --color-white: #ffffff;
  --color-black: #000000;
  --color-background: #202020
;
  --color-text-primary: #ffffff;
  --color-text-secondary: #E63E96;
  --color-text-dark: #000000;
}

/* Reset and Base Styles */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: var(--font-family-primary);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: var(--color-white);
  color: var(--color-text-dark);
  line-height: 1.6;
}

.App {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* Main Content */
.main-content {
  flex: 1 1;
  padding: 2rem 0;
}

.container {
  max-width: 1500px;
  margin: 0 auto;
  padding: 0 2rem;
}

/* Typography */
h1, h2, h3, h4, h5, h6 {
  margin-bottom: 1rem;
  font-weight: 600;
}

h2 {
  color: var(--color-secondary);
  font-size: 2rem;
  margin-bottom: 1.5rem;
}

p {
  margin-bottom: 1rem;
  color: var(--color-text-primary);
}

/* Utility Classes */
.text-center {
  text-align: center;
}

.text-primary {
  color: var(--color-primary);
}

.text-secondary {
  color: var(--color-secondary);
}

.bg-primary {
  background-color: var(--color-primary);
}

.bg-secondary {
  background-color: var(--color-secondary);
}

/* Scrolling Text Animation - Global Utilities */
.scrolling-text {
  display: inline-block;
  animation: scrollLeftContinuous 30s linear infinite;
  white-space: nowrap;
}

/* Continuous Scrolling Animation */
@keyframes scrollLeftContinuous {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

/* Global Speed Control for Scrolling Text */

.scrolling-text[data-speed="3"] {
  animation-duration: 100s;
}

.scrolling-text[data-speed="5"] {
  animation-duration: 80s;
}

.scrolling-text[data-speed="8"] {
  animation-duration: 70s;
}

.scrolling-text[data-speed="10"] {
  animation-duration: 60s;
}

.scrolling-text[data-speed="15"] {
  animation-duration: 47s;
}

.scrolling-text[data-speed="20"] {
  animation-duration: 40s;
}

.scrolling-text[data-speed="25"] {
  animation-duration: 35s;
}

.scrolling-text[data-speed="30"] {
  animation-duration: 30s;
}

.scrolling-text[data-speed="40"] {
  animation-duration: 25s;
}

.scrolling-text[data-speed="50"] {
  animation-duration: 20s;
}

.scrolling-text[data-speed="60"] {
  animation-duration: 15s;
}

.scrolling-text[data-speed="70"] {
  animation-duration: 12s;
}

.scrolling-text[data-speed="80"] {
  animation-duration: 10s;
}

.scrolling-text[data-speed="90"] {
  animation-duration: 8s;
}

.scrolling-text[data-speed="100"] {
  animation-duration: 6s;
}

/* Solid and Outline Text Effects - Global Utilities */
.solid {
  color: var(--color-white);
  -webkit-text-fill-color: var(--color-white);
}

.outline {
  color: transparent;
  -webkit-text-fill-color: transparent;
  -webkit-text-stroke: 1px var(--color-white);
  text-shadow: none;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-weight: 500;
}

/* Responsive Typography */
@media (max-width: 768px) {
  .container {
    padding: 0 1rem;
  }
  
  h2 {
    font-size: 1.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,wEAAwE;AACxE;EACE,gFAAgF;EAChF,+CAA+C;EAC/C,iDAAiD;EACjD,gDAAgD;EAChD,yKAAyK;;EAEzK,WAAW;EACX,wBAAwB;EACxB,6BAA6B;EAC7B;AACF;EACE,sBAAsB;EACtB,sBAAsB;EACtB;AACF;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA,0BAA0B;AAC1B;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,uCAAuC;EACvC,mCAAmC;EACnC,kCAAkC;EAClC,oCAAoC;EACpC,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA,iBAAiB;AACjB;EACE,SAAO;EACP,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,gDAAgD;AAChD;EACE,qBAAqB;EACrB,mDAAmD;EACnD,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA,4CAA4C;;AAE5C;EACE,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,sDAAsD;AACtD;EACE,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,2CAA2C;EAC3C,iBAAiB;EACjB,mCAAmC;EACnC,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* CSS Variables from Config - Fonts loaded dynamically via JavaScript */\n:root {\n  /* Typography - These will be overridden by JavaScript with values from config */\n  --font-family-primary: 'Montserrat', sans-serif;\n  --font-family-scrolling: 'Bebas Neue', sans-serif;\n  --font-family-footer: 'Josefin Sans', sans-serif;\n  --font-family-fallback: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  \n  /* Colors */\n  --color-primary: #E63E96;\n  --color-primary-dark: #B91C7C;\n  --color-secondary: #202020\n;\n  --color-white: #ffffff;\n  --color-black: #000000;\n  --color-background: #202020\n;\n  --color-text-primary: #ffffff;\n  --color-text-secondary: #E63E96;\n  --color-text-dark: #000000;\n}\n\n/* Reset and Base Styles */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: var(--font-family-primary);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: var(--color-white);\n  color: var(--color-text-dark);\n  line-height: 1.6;\n}\n\n.App {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Main Content */\n.main-content {\n  flex: 1;\n  padding: 2rem 0;\n}\n\n.container {\n  max-width: 1500px;\n  margin: 0 auto;\n  padding: 0 2rem;\n}\n\n/* Typography */\nh1, h2, h3, h4, h5, h6 {\n  margin-bottom: 1rem;\n  font-weight: 600;\n}\n\nh2 {\n  color: var(--color-secondary);\n  font-size: 2rem;\n  margin-bottom: 1.5rem;\n}\n\np {\n  margin-bottom: 1rem;\n  color: var(--color-text-primary);\n}\n\n/* Utility Classes */\n.text-center {\n  text-align: center;\n}\n\n.text-primary {\n  color: var(--color-primary);\n}\n\n.text-secondary {\n  color: var(--color-secondary);\n}\n\n.bg-primary {\n  background-color: var(--color-primary);\n}\n\n.bg-secondary {\n  background-color: var(--color-secondary);\n}\n\n/* Scrolling Text Animation - Global Utilities */\n.scrolling-text {\n  display: inline-block;\n  animation: scrollLeftContinuous 30s linear infinite;\n  white-space: nowrap;\n}\n\n/* Continuous Scrolling Animation */\n@keyframes scrollLeftContinuous {\n  0% {\n    transform: translateX(0);\n  }\n  100% {\n    transform: translateX(-50%);\n  }\n}\n\n/* Global Speed Control for Scrolling Text */\n\n.scrolling-text[data-speed=\"3\"] {\n  animation-duration: 100s;\n}\n\n.scrolling-text[data-speed=\"5\"] {\n  animation-duration: 80s;\n}\n\n.scrolling-text[data-speed=\"8\"] {\n  animation-duration: 70s;\n}\n\n.scrolling-text[data-speed=\"10\"] {\n  animation-duration: 60s;\n}\n\n.scrolling-text[data-speed=\"15\"] {\n  animation-duration: 47s;\n}\n\n.scrolling-text[data-speed=\"20\"] {\n  animation-duration: 40s;\n}\n\n.scrolling-text[data-speed=\"25\"] {\n  animation-duration: 35s;\n}\n\n.scrolling-text[data-speed=\"30\"] {\n  animation-duration: 30s;\n}\n\n.scrolling-text[data-speed=\"40\"] {\n  animation-duration: 25s;\n}\n\n.scrolling-text[data-speed=\"50\"] {\n  animation-duration: 20s;\n}\n\n.scrolling-text[data-speed=\"60\"] {\n  animation-duration: 15s;\n}\n\n.scrolling-text[data-speed=\"70\"] {\n  animation-duration: 12s;\n}\n\n.scrolling-text[data-speed=\"80\"] {\n  animation-duration: 10s;\n}\n\n.scrolling-text[data-speed=\"90\"] {\n  animation-duration: 8s;\n}\n\n.scrolling-text[data-speed=\"100\"] {\n  animation-duration: 6s;\n}\n\n/* Solid and Outline Text Effects - Global Utilities */\n.solid {\n  color: var(--color-white);\n  -webkit-text-fill-color: var(--color-white);\n}\n\n.outline {\n  color: transparent;\n  -webkit-text-fill-color: transparent;\n  -webkit-text-stroke: 1px var(--color-white);\n  text-shadow: none;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  font-weight: 500;\n}\n\n/* Responsive Typography */\n@media (max-width: 768px) {\n  .container {\n    padding: 0 1rem;\n  }\n  \n  h2 {\n    font-size: 1.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
